import React from 'react'
import PropTypes from 'prop-types'
import MyImage from '@shared/components/myImage'
import CustomLink from '@shared/components/customLink'
import { S3_PREFIX } from '@shared/constants'

export default function ReelArticle({ styles, data }) {
  return (
    <div className={'position-relative mw-100 h-100 pt-5 pb-3'}>
      <CustomLink href={`/${data?.oArticle?.oSeo?.sSlug}`} className="my-2 d-block">
        <MyImage src={S3_PREFIX + data?.oArticle?.oImg?.sUrl} className={`${styles.articleImg}`} alt="Image" width={350} height={250} />
      </CustomLink>
      <div className={`mb-0 ${styles.overlayTitle} px-3`}>
        <CustomLink href={`/${data?.oArticle?.oSeo?.sSlug}`} className="mb-1 d-block">
          <h6 className="m-0">{data?.oArticle?.sTitle}</h6>
        </CustomLink>
        {data?.sReelContent && (
          <div className={`${styles.twitterContent} mb-2`}>
            <p>{data?.sReelContent}</p>
          </div>
        )}
        <CustomLink href={`/${data?.oArticle?.oSeo?.sSlug}`} className="theme-text">
          Read Article...
        </CustomLink>
      </div>
    </div>
  )
}
ReelArticle.propTypes = {
  styles: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired
}
